import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
// import $ from 'jquery';
// import Popper from 'popper.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Benign ResizeObserver noise (layout libs / StrictMode). Capture-phase so CRA's
// webpack overlay never treats it as a fatal runtime error.
const isResizeObserverLoopError = (message = '') =>
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/i.test(
    String(message || '')
  );

window.addEventListener(
  'error',
  (event) => {
    if (isResizeObserverLoopError(event?.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true
);

// Soften observer callbacks so the browser is less likely to throw the loop error.
if (typeof window.ResizeObserver !== 'undefined') {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      let scheduled = false;
      let latestEntries = [];
      let latestObserver = null;
      super((entries, observer) => {
        latestEntries = entries;
        latestObserver = observer;
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          callback(latestEntries, latestObserver);
        });
      });
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
